import React from 'react';
import { Row, Col } from 'antd';
import { apiImageStatic } from '../../../../config/config';

const ProductExtras = ({ extras, productId }) => {
  return (
    <Row className="mt-30" gutter={35} type="flex" justify="start">
      {extras.map((extra, i) => {
        return (
          <Col className="mb-20" xs={24} sm={12} key={i.toString()}>
            <Row type="flex" justify="start" align="middle">
              <Col span={7}>
                <img
                  alt={extra.icon}
                  className="extra-image"
                  src={`${apiImageStatic}/extras/${productId}/${extra.icon}`}
                />
              </Col>
              <Col span={17}>
                <a
                  href={`${apiImageStatic}/extras/${productId}/${extra.file}`}
                  target="_blank"
                  rel="noreferrer noopener"
                  download
                >
                  <p className="extra-description">{extra.description}</p>
                </a>
              </Col>
            </Row>
          </Col>
        );
      })}
    </Row>
  );
};

export default ProductExtras;
